export async function fetchLoiPreparationUrl(
    axios: { post: (url: string, data: unknown, config?: { params?: Record<string, unknown> }) => Promise<{ data: { prepareUrl: string } }> },
    engagementId: number,
    eventId: string,
    buyerId: number,
): Promise<string> {
    const response = await axios.post(
        `/api/Marketplace/${engagementId}/LoiPreparation/PrepareUrl`,
        null,
        { params: { eventId, buyerId } },
    );
    return response.data.prepareUrl;
}

export async function fetchLoiPreparationStatus(
    axios: { get: (url: string, config?: { params?: Record<string, unknown> }) => Promise<{ data: { isPrepared: boolean } }> },
    engagementId: number,
    eventId: string,
    buyerId: number,
): Promise<boolean> {
    const response = await axios.get(
        `/api/Marketplace/${engagementId}/LoiPreparation/Status`,
        { params: { eventId, buyerId } },
    );
    return response.data.isPrepared;
}

export async function uploadLoiExecutedDocument(
    axios: { post: (url: string, data: unknown, config?: { params?: Record<string, unknown>; headers?: Record<string, string> }) => Promise<{ data: unknown }> },
    engagementId: number,
    buyerId: number,
    file: File,
): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    await axios.post(
        `/api/Marketplace/${engagementId}/LoiPreparation/UploadExecutedDocument`,
        formData,
        {
            params: { buyerId },
            headers: { 'Content-Type': 'multipart/form-data' },
        },
    );
}
